import $$ from 'cmn-utils'


const baseUrl = "/api/core/plane-position/";
export default {

    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    listByPlanePicture: (params) => {
        return $$.get(baseUrl + 'list-by-plane-picture', params)
    },

}